/**
 *  녹화 유형
 * local - 개인 녹화
 * server - 서버 녹화
 */
export const RECORDING_TYPE = {
    PERSONAL: "local",
    SERVER: "server"
};
